import React from "react";
import { Box, Skeleton, Paper } from "@mui/material";
import PageContainer from "../PageContainer";
import PageSection from "../PageSection";

const CirclesSkeleton: React.FC = () => {
  return (
    <PageContainer>
      {/* Stats Overview Skeleton */}
      <PageSection>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 3, md: 4 },
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 3,
              boxShadow: "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: { xs: 3, md: 5 },
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* Total Circles */}
              <Box sx={{ textAlign: "center" }}>
                <Skeleton
                  variant="text"
                  width={80}
                  height={60}
                  sx={{ mx: "auto", mb: 0.5 }}
                />
                <Skeleton variant="text" width={100} height={24} />
              </Box>

              {/* Divider */}
              <Skeleton
                variant="rectangular"
                width={2}
                height={60}
                sx={{ borderRadius: 1 }}
              />

              {/* Public Circles */}
              <Box sx={{ textAlign: "center" }}>
                <Skeleton
                  variant="text"
                  width={80}
                  height={60}
                  sx={{ mx: "auto", mb: 0.5 }}
                />
                <Skeleton variant="text" width={120} height={24} />
              </Box>
            </Box>
          </Paper>
        </Box>
      </PageSection>

      {/* Circles Grid Skeleton */}
      <PageSection>
        <Box>
          {/* Header Row */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1.8fr 1.8fr 1.1fr 1.1fr 1fr",
              gap: 2,
              px: 3,
              py: 1,
              mb: 1,
            }}
          >
            {["Circle Name", "Description", "Visibility", "Created", ""].map(
              (title, index) => (
                <Skeleton
                  key={index}
                  variant="text"
                  width={title ? "70%" : "0%"}
                  height={16}
                  sx={{ fontSize: "0.75rem" }}
                />
              )
            )}
          </Box>

          {/* Circle Cards */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {Array.from({ length: 4 }).map((_, index) => (
              <Paper
                key={index}
                elevation={0}
                sx={{
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 2,
                  p: 2.5,
                  minHeight: 80,
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1.8fr 1.8fr 1.1fr 1.1fr 1fr",
                    gap: 2,
                    alignItems: "center",
                  }}
                >
                  {/* Circle Name with avatar */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Skeleton variant="circular" width={40} height={40} />
                    <Box>
                      <Skeleton variant="text" width="80%" height={20} />
                      <Skeleton
                        variant="text"
                        width="60%"
                        height={16}
                        sx={{ mt: 0.5 }}
                      />
                    </Box>
                  </Box>

                  {/* Description */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      minHeight: "40px",
                    }}
                  >
                    <Box sx={{ width: "100%" }}>
                      <Skeleton variant="text" width="90%" height={16} />
                      <Skeleton
                        variant="text"
                        width="70%"
                        height={16}
                        sx={{ mt: 0.5 }}
                      />
                    </Box>
                  </Box>

                  {/* Visibility chip */}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Skeleton
                      variant="rounded"
                      width={80}
                      height={24}
                      sx={{ borderRadius: 3 }}
                    />
                  </Box>

                  {/* Created date */}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Skeleton variant="text" width="70%" height={20} />
                  </Box>

                  {/* Action buttons */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 1,
                      minHeight: "40px",
                      alignItems: "center",
                    }}
                  >
                    <Skeleton variant="circular" width={32} height={32} />
                    <Skeleton variant="circular" width={32} height={32} />
                  </Box>
                </Box>
              </Paper>
            ))}
          </Box>
        </Box>
      </PageSection>
    </PageContainer>
  );
};

export default CirclesSkeleton;
